import { render, staticRenderFns } from "./resources-group.vue?vue&type=template&id=5d6a5660"
import script from "./resources-group.vue?vue&type=script&lang=js"
export * from "./resources-group.vue?vue&type=script&lang=js"
import style0 from "./resources-group.vue?vue&type=style&index=0&id=5d6a5660&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports